import React, { useCallback, useEffect, useState } from "react";
import Dashboard from "components/dashboard";
import { Restricted, permissions } from "components/auth";
import Tabs from "components/tabs";
import { parsePage, parseParam, onChangeParam } from "components/table";
import { Tab } from "components/tabs";
import { PageSection } from "components/page";
import AssetPaginatedTable from "./table";
import { useAuthDataContext } from "components/auth";
import { GraphicsetPaginatedTable } from "pages/graphicset";
import { CustomerSelection } from "./list-page";
import { AddAction } from "components/buttons";
import DataGrid, { DataGridItem } from "components/data-grid";
import { getAssetCategoriesService } from "../../services/commonService";

const AssetListPage = ({ location: { search }, history, intl }) => {
  const { user } = useAuthDataContext();

  const handleChangeTab = index => {
    onChangeParam({ paramName: "tab", paramValue: index, query: search, history });
  };

  const [assetCategoryList, setAssetCategoryList] = useState([]);

  const assetCategoriesCallback = data => {
    setAssetCategoryList(data.map(category => category._id));
  };

  const getAssetCategories = useCallback(() => {
    getAssetCategoriesService(assetCategoriesCallback);
  }, []);

  useEffect(
    () => {
      getAssetCategories();
    },
    [getAssetCategories],
  );

  return (
    <Dashboard>
      <Restricted permissions={[permissions.asset_common_view, permissions.asset_view, permissions.graphicset_view]}>
        <Tabs selectedTab={parseParam({ queryParams: search, paramName: "tab" })} onChangeTab={handleChangeTab}>
          {user.permissions.includes(permissions.graphicset_view) && (
            <Tab label={intl.formatMessage({ id: "app.menu.graphicset.list" })}>
              <PageSection spaced={user.scopedViewByCustomer} hideBackground>
                <DataGrid>
                  <DataGridItem big>
                    <Restricted permissions={[permissions.graphicset_manage]}>
                      <AddAction url={`/graphicset/new`} />
                    </Restricted>
                    <CustomerSelection multiple={false} />
                  </DataGridItem>
                  <DataGridItem big>
                    <GraphicsetPaginatedTable
                      debounce={false}
                      pageName="graphicsetsPage"
                      page={parsePage({ queryParams: search, pageName: "graphicsetsPage" })}
                    />
                  </DataGridItem>
                </DataGrid>
              </PageSection>
            </Tab>
          )}
          {user.permissions.includes(permissions.asset_view) && (
            <Tab label={intl.formatMessage({ id: "app.menu.asset.list" })}>
              <PageSection spaced={user.scopedViewByCustomer} hideBackground>
                <DataGrid>
                  <DataGridItem big>
                    <Restricted permissions={[permissions.asset_manage]}>
                      <AddAction url={"/asset/new"} />
                    </Restricted>
                    <CustomerSelection multiple={false} />
                  </DataGridItem>
                  <DataGridItem big>
                    <AssetPaginatedTable
                      debounce={false}
                      pageName="assetsPage"
                      page={parsePage({ queryParams: search, pageName: "assetsPage" })}
                      variables={{ categoryIds: assetCategoryList }}
                    />
                  </DataGridItem>
                </DataGrid>
              </PageSection>
            </Tab>
          )}
          {user.permissions.includes(permissions.asset_common_view) && (
            <Tab label={intl.formatMessage({ id: "app.menu.commonAsset.list" })}>
              <PageSection hideBackground>
                <DataGrid>
                  <DataGridItem big>
                    <Restricted permissions={[permissions.asset_common_manage]}>
                      <AddAction url={"/asset/common/new"} />
                    </Restricted>
                  </DataGridItem>
                  <DataGridItem big>
                    <AssetPaginatedTable
                      commonAssets
                      pageName="commonAssetsPage"
                      page={parsePage({ queryParams: search, pageName: "commonAssetsPage" })}
                      variables={{ categoryIds: assetCategoryList }}
                    />
                  </DataGridItem>
                </DataGrid>
              </PageSection>
            </Tab>
          )}
        </Tabs>
      </Restricted>
    </Dashboard>
  );
};

export default AssetListPage;
